import { Box } from "@material-ui/core";
import { Navbar } from "../Components/Navbar/Navbar";
import Questions from "../Components/Questions/Questions";
import { BannerDriver } from "../Components/BannerDriver/BannerDriver";
import { Footer } from "../Components/Footer/Footer";
import style from "./FAQ.module.css";

const FAQ = () => {
  const QuestionSettins = {
    variant: "outlined",
    color: "primary",
    text: "Descarga la app",
  };

  const BannerDriverettins = {
    variant: "outlined",
    color: "primary",
    text: "Descarga la app",
  };
  return (
    <Box component="div" className={style.conteiner}>
      <Navbar />
      <Questions QuestionSettins={QuestionSettins} />
      <BannerDriver BannerDriverettins={BannerDriverettins} />
      <Footer />
    </Box>
  );
};

export default FAQ;
